import { defineComponent, onMounted, PropType, ref, watchEffect } from "vue";
import { gsap, Flip } from "gsap/all";
gsap.registerPlugin(Flip);
export default defineComponent({
  props: {
    images: { type: Array as PropType<string[]>, required: true },
    imageStreamsCount: { type: Number, default: 3 },
  },
  setup() {
    const container = ref<HTMLElement | null>(null);

    onMounted(() => {
      makeStreamTimelines();

      //   props.images.forEach((image) => {
      //     const imageElement = document.createElement("img") as HTMLImageElement;
      //     imageElement.src = image;
      //     imageElement.classList.add("backgroundimage");
      //     container.value!.appendChild(imageElement);
      //   });
    });
    watchEffect(() => {
      makeStreamTimelines();
      //   console.log("New images", props.images, length);
      //   props.images.forEach((image) => {
      //     const imageElement = document.createElement("img");
      //     imageElement.src = image;
      //     imageElement.classList.add("backgroundimage");
      //     container.value!.appendChild(imageElement);
      //   });
    });

    const makeStreamTimelines = (): void => {
      const images = container.value?.querySelectorAll(
        ".backgroundimage__image"
      );

      images!.forEach((image) => {
        const state = Flip.getState(image);

        image.classList.add("top");
        Flip.from(state, {
          absolute: true, // uses position: absolute during the flip to work around flexbox challenges
          duration: 0.5,
          stagger: 0.1,
          ease: "power1.inOut",
          // you can use any other tweening properties here too, like onComplete, onUpdate, delay, etc.
        });
      });
    };

    return { container };
  },
});
